<div id="loading-spinner">
  <img src="assets/spinner.gif" alt="pombase.org" />
  <div id="loading-spinner-text">
    Loading ...
  </div>
</div>
